import { PublishableDisplayableItemsViewModel } from '../../../../../shared/components/displayable-content/displayable-item-list/publishable-displayable-items-view-model';
import { TemplateDomainModel } from '../../../../../../domainModels/template-domain-model';
import { WebTemplatesContainerViewModel } from '../web-templates-container/web-templates-container-view-model';
import { NavigationService } from '../../../../../../services/navigation.service';
import { Injectable, Injector, NgZone } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MenuType } from '../../../../../../models/utils/dto/menu-type-definition';

@Injectable()
export class WebSpotlightTemplatesViewModel extends PublishableDisplayableItemsViewModel {
  constructor(
    protected templatesDomainModel: TemplateDomainModel,
    // webTemplatesContainerViewModel provided by the Logged In Scope - need to get access to which tag is selected,
    // only way to pass this data to child is via a shared model, because child component is being created
    // by tab bar component (inflated in non conventional way), which means I can't pass in inputs
    protected webTemplatesContainerViewModel: WebTemplatesContainerViewModel,
    navigationService: NavigationService,
    ngZone: NgZone,
    ngbModal: NgbModal,
    injector: Injector
  ) {
    super(webTemplatesContainerViewModel, navigationService, ngZone, ngbModal, injector);
    this.setupFilter();
  }

  protected defaultEmptyStateTitle = 'No Web Spotlight Templates';

  protected itemsToFilter$ = this.templatesDomainModel.webSpotlightMenuTemplates$;

  protected getEmptyStateTitleCopy(menuTypeFilter: string): string {
    return this.genericEmptyStateTitleCopyForTemplates(menuTypeFilter, 'web spotlight templates');
  }

  openCreateWebSpotlightTemplateModal() {
    this.openCreateTemplateModal(MenuType.WebSpotlightMenu);
  }
}
